var map = {
	"./Pin-Dark-Delegacia.svg": 666,
	"./Pin-Dark-Moto.svg": 667,
	"./Pin-Dark-Ocorrencia.svg": 668,
	"./Pin-Dark-Policial.svg": 669,
	"./Pin-Dark-Viatura.svg": 670,
	"./Pin-Light-Delegacia.svg": 671,
	"./Pin-Light-Moto.svg": 672,
	"./Pin-Light-Ocorrencia.svg": 673,
	"./Pin-Light-Policial.svg": 674,
	"./Pin-Light-Viatura.svg": 675,
	"./X.svg": 1234,
	"./camera.svg": 1235,
	"./clusterDarkBig.svg": 1236,
	"./clusterDarkSmall.svg": 1237,
	"./clusterLightBig.svg": 1238,
	"./clusterLightSmall.svg": 1239,
	"./logo.svg": 1240,
	"./lpr.svg": 1241,
	"./lpr_third_party.svg": 676,
	"./motorcycle-pin-dark.svg": 1242,
	"./motorcycle-pin-light.svg": 1243,
	"./motorcycle-pin-lightAlt.svg": 1244,
	"./panoramic.svg": 1245,
	"./panoramic_third_party.svg": 677,
	"./pin_event.svg": 1246,
	"./pin_point_of_interest.svg": 366,
	"./pinned.svg": 1247,
	"./pinned_third_party.svg": 678,
	"./ptz.svg": 1248,
	"./ptz_third_party.svg": 679,
	"./user-agent-dark.svg": 1249,
	"./user-agent-light.svg": 1250,
	"./user-agent-lightAlt.svg": 1251,
	"./vehicle-pin-dark.svg": 1252,
	"./vehicle-pin-light.svg": 1253,
	"./vehicle-pin-lightAlt.svg": 1254
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 365;